module.exports = __webpack_public_path__ + "static/media/star_checked.0ecd75ce.svg";